import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        loadMoreButton: {
            marginTop: theme.spacing(2),
        },
        paginationConatiner: {
            marginTop: theme.spacing(2),
        },
    })
})
